/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupVault } from '../models/BackupVault';

export class GetVaultResponse {
  'vault': BackupVault;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vault",
      "baseName": "vault",
      "type": "BackupVault",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetVaultResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

